'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _argTypes = require('../../utils/argTypes');

var _argTypes2 = _interopRequireDefault(_argTypes);

require('./Image.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image = function Image(props) {
  var src = props.src,
      name = props.name,
      onClick = props.onClick;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('img', { src: src, alt: name, style: Object.assign({}, props.style), onClick: onClick })
  );
};

exports.default = Image;


Image.defaultProps = {
  onClick: undefined,
  src: '#',
  alt: 'Add Image Name'
};

Image.propTypes = {
  src: _propTypes2.default.string,
  name: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

Image.args = [{
  title: 'Source URL',
  key: 'src',
  type: _argTypes2.default.STRING
}, {
  title: 'Name',
  key: 'alt',
  type: _argTypes2.default.STRING
}];

//# sourceMappingURL=Image.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.image/dist/components/Image/Image.js
// module id = 484
// module chunks = 0